import * as React from 'react';
import { Link } from 'gatsby';
import { Helmet } from 'react-helmet';
import Layout from '../components/layout';

const PauText = () => {
  return (
    <Layout
      title='El cos del paisatge, Pau Guerrero'
      description='Text de Pau Guerrero. Presentació del projecte fotogràfic Cos - Paisatge. La fotografia de paisatge és, per a mi, una activitat indissociable a caminar per la muntanya. Mes que sortir a fotografiar el paisatge, surto a caminar acompanyat d’un aparell fotogràfic.'
      path='pau-guerrero-text'
      ogType='article'
    >
      <>
        <Helmet>
          <meta property='og:article:author' content='Pau Guerrero' />
          <meta
            property='og:article:tag'
            content='art, fotografia, cos, paisatge'
          />
        </Helmet>
        <h2 className='textHeading'>El cos del paisatge</h2>
        <blockquote cite='https://ca.wikipedia.org/wiki/Fr%C3%A9d%C3%A9ric_Gros'>
          <p className='textParagraph'>
            Andar nunca requiere nada más que el cuerpo. Ni el saber, ni las
            lecturas ni las relaciones tienen utilidad alguna: bastan dos
            piernas, y unos ojos muy abiertos para ver.
          </p>
        </blockquote>
        <figcaption>
          - Frédéric Gros, <cite>Andar, una filosofía</cite>
        </figcaption>
        <p>
          La fotografia de paisatge és, per a mi, una activitat indissociable a
          caminar per la muntanya. Mes que sortir a fotografiar el paisatge,
          surto a caminar acompanyat d’un aparell fotogràfic. I és el fet de
          caminar que transforma com veig el paisatge, deixant de ser una imatge
          bonica i estàtica que es mira còmodament de lluny.
        </p>
        <p>
          Caminar durant llargues estones, dies sencers si som afortunats i
          tenim el temps, ens apropa íntimament al lloc on ens trobem.
        </p>
        <p>
          El nostre cos es fa present alhora que el paisatge agafa una concreció
          i materialitat, la profunditat que li dóna el temps, i l’esforç, que
          passem caminant-hi.
        </p>
        <p>
          Cos i Terra entren en ressonància, el paisatge ja no és una imatge que
          veiem allà únicament per al gaudi estètic i visual, sinó que esdevé un
          entorn viscut.
        </p>
        <p>
          Distancies i desnivells deixen de ser mides abstractes, i el cos passa
          a ser la nostra pauta, cada pas i cada respiració la nostra pròpia
          mesura, mentre seguim el sender que puja a la muntanya.
        </p>
        <p>
          D’alguna manera caminar aporta realitat al paisatge, l’apropa al cos i
          el fa passar a través d’ell. L’esforç, la respiració, totes les
          sensacions físiques ens conviden a una relació íntima amb el paisatge,
          alhora que el gaudi arrela en el cos.
        </p>
        <p>
          Aquesta intimitat terrena transfigura el paisatge, mostrant-nos tot un
          conjunt de característiques i singularitats, trets físics
          reconeixibles alhora com a trets corporals.
        </p>
        <p>
          Com si la terra ens piqués l’ullet, de la mateixa manera que desperta
          el nostre cos, la natura desvela una corporalitat que ens crida i ens
          sedueix.
        </p>
        <p className='textFirma'>Pau Guerrero</p>
        <div className='textLinks'>
          <div className='textLink'>
            <Link to='/cv-pau-guerrero'>CV</Link>
          </div>
          {/* <div className='textLink'>
            <Link to='/'>Fotografies</Link>
          </div> */}
        </div>
      </>
    </Layout>
  );
};

export default PauText;
